import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { EMPTY, finalize } from 'rxjs';

let _activeRequest = 0
let _activeRequestKeys = new Set<string>();

export function incrementRequest() {
  _activeRequest++;
  if (_activeRequest === 1) showSpinner()
}

export function decrementRequest() {
  _activeRequest--;
  if (_activeRequest === 0) hideSpinner()
}

function showSpinner() {
  const spinner = document.getElementById('custom-spinner')
  if (spinner) {
    spinner.hidden = false
  }
}

function hideSpinner() {
  const spinner = document.getElementById('custom-spinner')
  if (spinner) {
    spinner.hidden = true
  }
}

export const TOAST_LOADING = new HttpContextToken(() => false);
export const SKIP_LOADING = new HttpContextToken(() => false);

export const PeticionApiInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(SKIP_LOADING) || req.context.get(TOAST_LOADING)) {
    return next(req)
  }

  const isFormData = req.body instanceof FormData;
  const key = req.method + req.urlWithParams + JSON.stringify(req.body ?? {});
  if (!isFormData) {
    if (_activeRequestKeys.has(key)) {
      return EMPTY;
    }
    _activeRequestKeys.add(key);
  }

  if (_activeRequest == 0) {
    showSpinner()
  }
  _activeRequest++

  return next(req).pipe(
    finalize(() => {
      if (!isFormData) _activeRequestKeys.delete(key);
      _activeRequest--
      if (_activeRequest == 0) {
        hideSpinner()
      }
    })
  )
}